import React, { Component, cloneElement } from "react";
import {
  List,
  CreateButton,
  Datagrid,
  TextField,
  DateField,
  required,
  EditButton,
  DeleteButton,
  TopToolbar,
  RefreshButton,
  AutocompleteInput,
  Filter,
  ReferenceInput,
  SelectInput,
  NumberInput,
  useRecordContext,
  useResourceContext,
} from "react-admin";
import { Scrollbars } from "react-custom-scrollbars";
import { GetCurrentUserRoles, monthList } from "../common/common";

import Modal from "react-responsive-modal";

const LoyaltyPointsFilter = (props) => {
  const noOftargets = [...Array(3).keys()];
  const record = useRecordContext();
  console.log("record....Show", record);
  console.log("LoyaltyPointsFilter prop===>", props);
  const currentYear = new Date().getFullYear();
  const startYear = 2019;
  const years = [];

  for (let i = startYear; i <= currentYear; i++) {
    years.push({ id: i, name: i.toString() });
  }

  console.log("umesh jadhav", years);
  return (
    <Filter {...props}>
      <ReferenceInput
        label="Sold To Name"
        source="business_id"
        reference="businesses"
        linkType="show"
        allowEmpty
      >
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
      <SelectInput
        source="month"
        label="Month"
        choices={[
          { id: 1, name: "January" },
          { id: 2, name: "February" },
          { id: 3, name: "March" },
          { id: 4, name: "April" },
          { id: 5, name: "May" },
          { id: 6, name: "June" },
          { id: 7, name: "July" },
          { id: 8, name: "August" },
          { id: 9, name: "September" },
          { id: 10, name: "October" },
          { id: 11, name: "November" },
          { id: 12, name: "December" },
        ]}
        validate={required()}
      />
      <SelectInput
        source="year"
        label="Year"
        choices={years}
        validate={required()}
      />

      <NumberInput
        source="loyalty_points_gt"
        label="Loyalty Points greater than equal to"
        min={0}
        // max={props.filterValues.loyalty_points_lt}
      />
      <NumberInput
        source="loyalty_points_lt"
        label="Loyalty Points less than equal to "
        min={0}
      />
    </Filter>
  );
};

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const ListActions = ({
  basePath,
  filterValues,
  total,
  maxResults,
  currentSort,
  exporter,
  permanentFilter,
  showFilter,
  displayedFilters,
  filters,
}) => {
  const record = useRecordContext();
  console.log("record....Show", record);
  const resource = useResourceContext();
  let roleData = GetCurrentUserRoles();
  let createBtn = false;
  if (roleData.indexOf("$csa") > -1 || roleData.indexOf("$ca") > -1) {
    createBtn = true;
  }
  return (
    <TopToolbar>
      {filters &&
        cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: "button",
        })}
      <RefreshButton />
      {createBtn && <CreateButton label="Import" basePath={resource} />}
    </TopToolbar>
  );
};

const MonthName = () => {
  const record = useRecordContext();
  console.log("record....Show", record);
  const resource = useResourceContext();
  return <span>{monthList[Number(record.month) - 1]}</span>;
};

const LoyaltyPointsList = (props) => {
  const noOftargets = [...Array(3).keys()];
  let roleData = GetCurrentUserRoles();
  let editBtn = false;
  if (roleData.indexOf("$csa") > -1 || roleData.indexOf("$ca") > -1) {
    editBtn = true;
  }

  return (
    <React.Fragment>
      <Scrollbars class="scroll-container">
        <List
          {...props}
          sort={{ field: "created_at", order: "DESC" }}
          undoable={false}
          filters={<LoyaltyPointsFilter />}
          title="Loyalty Points"
          actions={<ListActions />}
        >
          <Datagrid bulkActionButtons={false}>
            {/* <UserName label="Sales Officers Name" /> */}
            <TextField source="sap_code" label="Sold To ID" />
            {/* <ReferenceField label="Sold To Name" source="business_id" reference="businesses" link="show" allowEmpty >
                                <TextField source="name" />
                            </ReferenceField> */}
            <TextField source="business_name" label="Sold To Name" />
            <MonthName source="month" label="Month" />
            <TextField source="year" label="Year" />
            <TextField source="points" label="Loyalty Points" />
            <DateField
              source="created_at"
              label="Record Created At"
              showTime={true}
            />
            {editBtn && <EditButton />}
            {editBtn && <DeleteButton />}
          </Datagrid>
        </List>
      </Scrollbars>
    </React.Fragment>
  );
};

export default LoyaltyPointsList;
